import $ from 'jquery'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import memoize from 'lodash/memoize'
import { transformExtent as OLProjTransformExtent } from 'ol/proj'

import { setActiveTab } from 'api/actions'
import { HistoryUpdate } from 'api/history'
import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziAddFeature from 'drawer/tabs/info/add-feature'
import PoziDrawerTabInfo from 'drawer/tabs/info/info'
import { endAnnotation } from 'drawer/tabs/layers/annotations/actions'
import ScrollPositionInit, { setScrollPosition } from 'drawer/tabs/ScrollPosition'
import PoziDrawerTabToolsLogin from 'drawer/tabs/tools/login'
import PoziDrawerTabTools from 'drawer/tabs/tools/tools'
import PoziMap from 'map/map'
import IsSmallScreen, { SMALL_SCREEN_PIXELS } from 'utils/IsSmallScreen'
import { currentTargetLayerClear, targetGetCenter, targetUnset } from 'utils/target'

import { WhatsHereClear } from './tabs/info/WhatsHereUtils'
import PoziMeasure from './tabs/tools/measure'

/*
 * Events
 *  app.event.drawer.opening
 *  app.event.drawer.open
 *  app.event.drawer.closing
 *  app.event.drawer.closed
 */

/**
 * Pozi MDL Drawer Adapter
 */
const PoziDrawer = memoize(function () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    show: function (activeTab) {
      return show(activeTab)
    },
    hide: function (evt) {
      return hide(evt)
    },
    updateMDL: function () {
      return updateMDL()
    }
  }

  const app = PoziUtils.getApp()

  /**
   * Add events for drawer
   */
  var init = function () {
    $(window).resize(function () {
      if (window.resizeDrawerReduce) {
        clearTimeout(window.resizeDrawerReduce)
      }
      window.resizeDrawerReduce = setTimeout(function () {
        PoziMap().resize()
      }, 200)
    })

    ScrollPositionInit()

    Model.on('app.drawer.activetabid', function PoziHistoryOnAppDrawerActiveTabID(value) {
      // console.debug('activetabid', value)

      if (value === '') {
        console.log('No active tab selected')
        return
      }
      if (value === 'layers') {
        window.setTimeout(function () {
          // Do not put the keyboard focus on the layer search box on small mobile devices
          if (IsSmallScreen(SMALL_SCREEN_PIXELS)) {
            return
          }
          console.log('Focus search box on layers tab.')
          const el = document.getElementById('tab-layers-filter')
          if (!isNil(el)) {
            el.focus()
          }
        }, 0)
      }
      const bDrawOpen = Model.get('app.event.drawer.open', false)
      if (!bDrawOpen) {
        Model.set('app.event.drawer.opening', true)
      }
      const windowMode = Model.get('app.event.window.mode', '')
      if (windowMode === 'mobile' || window.innerHeight < 500) {
        $('#logoDiv').hide()
      }
      Model.setState('tab', null, value)
      HistoryUpdate()
      show(value)
      if (!bDrawOpen) {
        Model.set('app.event.drawer.opening', false)
      }
      Model.set('app.event.drawer.open', true)
    })

    Model.on('app.state.tab', close)

    PoziDrawerTabInfo().init()
    // PoziDrawerTabSearch().init()
    // PoziDrawerTabToolsShare().init()
    // PoziDrawerTabToolsBuffer().init()
    PoziDrawerTabToolsLogin().init()
    PoziDrawerTabTools().init()

    $('#pozi-drawer-tabs-button-hide').on('click', hide)
    // Map icon drawer open to layer control.
    $('#drawer-show').on('click', function () {
      Model.set('app.drawer.activetabid', 'layers')
    })
    $('#search-input-dummy').on('click', function () {
      Model.set('app.drawer.activetabid', 'search')
    })
    $('#search-input-icon-dummy').on('click', function () {
      Model.set('app.drawer.activetabid', 'search')
    })
    $('#submit-button-dummy').on('click', function () {
      Model.set('app.drawer.activetabid', 'search')
    })

    PoziDrawer().updateMDL()

    const tab = Model.getState('tab', null)
    if (tab) {
      Model.set('app.drawer.activetabid', tab)
    }

    Model.on('app.event.drawer.open', _drawOpen)
    Model.on('app.event.drawer.closed', _drawClosed)
  }

  var _drawClosed = function (value) {
    // $('.ol-scale-line').show()
    Model.set('app.event.drawer.open', false)
  }

  var _drawOpen = function (value) {
    const windowMode = Model.get('app.event.window.mode', '')
    if (windowMode === 'mobile') {
      // $('.ol-scale-line').hide()
    } else {
      // $('.ol-scale-line').show()
    }
  }

  var close = function (value) {
    if (!value) {
      console.log('Drawer closing...')
      Model.set('app.event.drawer.closing', true)
      PoziUtils.clearLayersTurnedOnWhileOnInfoPanel()
      targetUnset()
      PoziMap().unselectAllFeatures()
      // app.poziMap.removeAllOverlayFeatures() // ??
      Model.set('app.event.drawer.closed', true)
      const windowMode = Model.get('app.event.window.mode', '')
      if (windowMode === 'mobile') {
        $('#logoDiv').show()
      }

      const layer = Model.get('app.feedback.layer', null)
      if (!isNil(layer)) {
        console.log('Refresh source', layer.titleid)
        const olLayer = PoziUtils.getOpenLayersObjectFromTitleID(layer.titleid)
        olLayer.getSource().clear(true)
        olLayer.getSource().refresh()
        Model.unset('app.feedback.layer')
      }

      window.store.dispatch(endAnnotation())
      window.store.dispatch(setActiveTab())
    }
  }

  /**
   * Update MDL
   */
  var updateMDL = function () {
    $('*').removeAttr('data-upgraded')
    $('*').removeClass('is-upgraded')
    if (window.componentHandler) {
      window.componentHandler.upgradeDom()
    }
  }

  /**
   * Show drawer
   */
  var show = function (activeTab) {
    if (!activeTab || activeTab === '') {
      console.error('Drawer().show: !!! Invalid activeTab !!.')
      return
    }

    // PoziAddFeature().removeSelectedPointLayer()

    // Close the legend popover
    $('#legendButton').popover('hide')

    // remove all is-active classes from tabs
    $('a.mdl-tabs__tab').removeClass('is-active')
    // remove all is-active classes from panels
    $('.mdl-tabs__panel').removeClass('is-active')

    // activate desired tab
    $('.pozi-drawer-tabs-' + activeTab).addClass('is-active')
    // activate desired tab panel
    $('#pozi-drawer-tabs-panel-' + activeTab).addClass('is-active')

    setScrollPosition(activeTab)

    // $('.pozi-drawer-tabs-panel-wrapper').height($('.mdl-layout__drawer').height() - $('.pozi-drawer-tabs-wrapper').height())

    $('.mdl-layout__drawer').removeClass('pozi-layout-drawer-hide').addClass('pozi-layout-drawer-show')

    HistoryUpdate()

    const drawerVisible = Model.get('app.event.drawer.visible', false)
    const action = drawerVisible ? 'Drawer Tab select' : 'Drawer Open'

    console.debug(action, activeTab)
    PoziUtils.gtag({
      category: 'useraction',
      status: 'success',
      identifier: activeTab,
      action
    })

    Model.set('app.event.drawer.visible', true)
    PoziMap().resize()

    const bDrawerOpening = Model.get('app.event.drawer.opening', false)
    if (bDrawerOpening) {
      window.setTimeout(() => {
        const targetCenter = targetGetCenter()
        if (!isNil(targetCenter)) {
          // console.log('Drawer().show: targetCenter', targetCenter)
          const xy = get(targetCenter, 'geometry.coordinates', null)
          if (!isNil(xy)) {
            const extent = app.map.getView().calculateExtent(app.map.getSize())
            if (isNil(extent)) {
              return
            }
            const view = OLProjTransformExtent(extent, 'EPSG:3857', 'EPSG:4326')
            if (isNil(view)) {
              return
            }
            // console.log('Drawer().show: current view', view, xy, extent)
            const windowMode = Model.get('app.event.window.mode', '')
            if (windowMode === 'mobile') {
              // console.log('Drawer().show: Always center target for mobile mode.')
              PoziMap().setCenter(xy)
            } else if (xy[0] < view[0] || xy[0] > view[2] || xy[1] < view[1] || xy[1] > view[3]) {
              // console.log('Drawer().show: Target hidden center it.')
              PoziMap().setCenter(xy)
            } else {
              // console.log('Drawer().show: Target not hidden in desktop mode. Do not center.')
            }
          }
        }
      }, 100)
    }
  }

  /**
   * Hide drawer
   */
  var hide = function (evt) {
    PoziUtils.eventHandled(evt)

    if ($('.mdl-layout__drawer').hasClass('pozi-layout-drawer-hide')) {
      console.log('Drawer already closed.')
      return
    }

    const selectedTab = Model.get('app.state.tab', [])[0]

    Model.unset('app.state.tab') // Clear selected tab
    PoziDrawerTabInfo().hide()

    // Clear whats here
    WhatsHereClear()

    // Clear the current target layer
    currentTargetLayerClear()

    // Hide any drawings
    PoziMeasure().clear()

    PoziAddFeature().removeSelectedPointLayer()

    console.debug('Drawer closed.', selectedTab)
    PoziUtils.gtag({
      category: 'useraction',
      status: 'success',
      identifier: selectedTab,
      action: 'Drawer close'
    })
    Model.set('app.event.drawer.visible', false)
    Model.set('app.drawer.activetabid', '')

    PoziMap().resize()

    $('.mdl-layout__drawer').removeClass('pozi-layout-drawer-show').addClass('pozi-layout-drawer-hide')

    return false
  }

  // Return adapters (must be at end of adapter)
  return adapters
})

export default PoziDrawer
